<template>
  <div id="projects">
    <v-toolbar>
      <v-toolbar-title>
        <span>{{'medias._medias_list_'|translate}} {{medias.length}}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="newMedia" color="primary" dark class="mb-2">{{'medias._new_media_'|translate}}</v-btn>

    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="medias"
      :pagination.sync="pagination"
      :item-key="id"
      :loading="loading"
      class="elevation-1"
    >

      <template slot="items" slot-scope="props">
        <tr style="cursor: pointer">
          <td class="text-xs-left">{{ props.item.title}}</td>
          <td class="text-xs-left">{{ props.item.category }}</td>
          <td class="text-xs-left">{{ props.item.created_date }}</td>
          <td class="text-xs-left">{{ props.item.created_by }}</td>
           <td class="text-xs-left">{{ props.item.data_type }}</td>
          <td class="text-xs-left">{{ props.item.description }}</td>
          <td class="text-xs-left">{{ props.item.tags}}</td>
      
           <!--TODO check by data type -->
           <td class="text-xs-left">
             <div v-viewer class="images clearfix">
              <template v-if="props.item.data_type=='image'">
                <img :src="props.item.url" class="image" >
                </template>
        

                <audio v-else-if="props.item.data_type=='audio'"
              controls
              :src="props.item.url">
              Your browser does not support the
              <code>audio</code> element.
              </audio>
                   
               <video width="320" height="240" controls v-else-if="props.item.data_type=='video'">
            <source :src="props.item.url" type="video/mp4">
            Your browser does not support the video tag.
            </video> 
            </div>

            
             
             </td>
         
          <td class="text-xs-left">
           
            <v-btn @click.stop="editItem(props.item)" flat icon color="grey">
              <v-icon>edit</v-icon>
            </v-btn>
          </td>

            <td class="text-xs-left">
            <v-btn @click.stop="deleteMedia(props.item)" flat icon color="grey">
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { db } from "@/api/firebaseInit";
import firebase from "firebase";
export default {
  name: "widget-medias",
   computed: {
    medias(){
    
      let medias =  this.$store.getters.medias;
        this.loading=false
      return medias;
    }
  },
    watch: {
   medias(){
    
      let medias =  this.$store.getters.medias;
       this.loading=false
      return medias;
    }
  },
  data() {
    return {
      created_by_id:"",
      created_by:"",
    //  jobs: [],
      loading: true,
      pagination: {
        sortBy: "title",
        rowsPerPage: "100"
      },
      id: null,
      media_id:'',
      headers: [
        {text: this.$t('medias._media_name_'),align: "left",value: "title"},
        { text: this.$t('medias._media_category_'), value: "category" },
        { text: this.$t('medias._media_createdDate_'), value: "created_date" },      
        { text: this.$t('medias._media_createdBy_'), value: "created_by" },
        { text: this.$t('medias._media_type_'), value: "data_type" },
        { text: this.$t('medias._media_desc_'), value: "description" },
        { text:this.$t('medias._media_tags_'), value: "tags" },
        { text: this.$t('medias._media_url_'), value: "url" },
        { text: this.$t('medias._media_edit_'), value: "Edit" },
        { text: this.$t('coupons._Delete_'), value: "Delete" }
      ],

    };
  },
    created() {  
    this.created_by_id = firebase.auth().currentUser.uid;
    this.created_by = firebase.auth().currentUser.displayName;
  },
  mounted() {
  //  this.FetchProjects();
  },
  methods: {

       deleteMedia(media) {
      var that = this;
      if (confirm("Are you sure?")) {
        db.collection("medias")
          .doc(media.id)
          .delete()
          .then(function() {
            alert('This medias was deleted');
           
          });
           this.$store.dispatch('fetchMedias')
           // this.$router.push({name: 'widget-coupons'});
      }
    },

    editItem(item) {
      this.selected = item;
      this.$router.push({
        name: "components/modifiers-editmedia",
        params: {
          media_id: item.id
        }
      });
    },

    newMedia() {
      const that = this;
      const memberRef = db.collection("medias").doc();
      const refKey = memberRef.id;
      this.media_id = refKey;
      memberRef
        .set({
                created_by:this.created_by,
                created_by_id:this.created_by_id,
                id: this.media_id,
                category:'',
                created_date:new Date(),
                data_type:'', 
                description:'', 
                tags:'',
                title:'',
                url:''

        })
        .then(() => {
           this.$router.push({
            name: "components/modifiers-editmedia",
            params: {
              media_id: that.media_id
            }
          });
        })
        .catch(error => {
          console.error("Error adding media: ", error);
        });
    }
  }
};
</script>
<style>
.image {
  height: 20px;
  cursor: pointer;
  margin: 5px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/pages/widgets/Medias.vue